import { Component } from 'react';
import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error
    };
  }
  render() {
    if (this.state.hasError && this.state.error) {
      if (this.props.fallback) {
        return this.props.fallback(this.state.error);
      }
      return /*#__PURE__*/_jsx(Alert, {
        type: "danger",
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app-governance-lib.errorBoundary.default.title"
        }),
        children: /*#__PURE__*/_jsx("p", {
          children: this.state.error.message || /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app-governance-lib.errorBoundary.default.message"
          })
        })
      });
    }
    return this.props.children;
  }
}